"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikTextArea = void 0;
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var FormikTextArea = function (props) {
    var _a, _b;
    var context = formik_1.useFormikContext();
    var field = context.getFieldProps(props.name);
    var propBag = __assign(__assign(__assign({}, props), field), { value: (_b = (props.linesAsArray ? (_a = field.value) === null || _a === void 0 ? void 0 : _a.join('\r\n') : field.value)) !== null && _b !== void 0 ? _b : '', onChange: function (e) {
            var _a;
            var value = e.target.value;
            if (props.linesAsArray) {
                value = value.split(/\r?\n/);
            }
            context.setFieldValue(props.name, value);
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value);
        }, onBlur: function (e) {
            var _a, _b;
            (_a = field.onBlur) === null || _a === void 0 ? void 0 : _a.call(field, e);
            (_b = props.onBlur) === null || _b === void 0 ? void 0 : _b.call(props, e);
        } });
    return react_1.default.createElement(morse_react_1.TextArea, __assign({ id: props.name }, propBag));
};
exports.FormikTextArea = FormikTextArea;
//# sourceMappingURL=FormikTextArea.js.map